//Get Setting
export const GET_SETTING = "GET_SETTING";

//Update Setting
export const UPDATE_SETTING = "UPDATE_SETTING";


//Toggle Switch
export const HANDLE_TOGGLE_SWITCH = "HANDLE_TOGGLE_SWITCH";

export const HANDLE_SELLER_TOGGLE_SWITCH = "HANDLE_SELLER_TOGGLE_SWITCH";

// App Version
export const UPDATE_APP_VERSION = "UPDATE_APP_VERSION";